import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import React from "react";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import FurnitureSetIconPath from "@ingka/ssr-icon/paths/furniture-set";
import styles from "../../../styles/common-styles.module.css";

interface ItemCardLocalCombinationProps {
  item: Item;
}

export const ItemCardLocalCombination = ({
  item,
}: ItemCardLocalCombinationProps) => {
  const badges: ItemBadge[] = [
    {
      text: "Local combination/SPR",
      colour: "white",
    },
  ];
  return (
    <ItemCard badges={badges as ItemBadge[]}>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={""} fallbackImageIcon={FurnitureSetIconPath} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNo itemNo={item.noFormatted} />
        </div>
      </div>
    </ItemCard>
  );
};
